import { AxiosPromise } from 'axios'
import { createUsersClient } from './createUsersClient'
import { createUser } from './methods'
import { User, UserResponse, UsersClient as BaseUsersClient, UsersClientOption } from './types'

export default function UserClient(options?: UsersClientOption): UsersClient {
  const commonOptions = {}

  return createUsersClient({
    ...commonOptions,
    ...options,
    methods: {
      createUser,
    },
  })
}

export type UsersClient = BaseUsersClient & {
  readonly createUser: (user: Omit<User, 'has_avatar'>) => AxiosPromise<UserResponse>;
}
